import React from 'react'
import { Card, CardContent, IconButton, makeStyles, Typography } from '@material-ui/core'
import { indigo } from '@material-ui/core/colors'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'relative',
		textAlign: 'center',
		'&:hover': {
			color: 'darkgrey',
		},
	},
	iconButtonPlay: {
		position: 'absolute',
		opacity: 0,
		right: 16,
		top: 16,
		width: 42,
		height: 42,
		color: 'darkgrey',
		transition: 'color 0.25s, opacity 0.25s',
		'&:hover': {
			color: 'lightgray',
		},
	},
	iconPlay: {
		fontSize: 24,
	},
}))

const ChordCard = (props: {
	chord: any,
	onChange?: (chord: any) => void,
	onPlayClick: (chord: any) => void,
	selected?: boolean
}) => {

	const {
		chord,
		onChange,
		selected = false,
		onPlayClick
	} = props

	const classes = useStyles()

	return (
		<div className={classes.container}>
			<Card
				className='chord-card'
				style={{
					width: 190 - (selected ? 6 * 2 : 0),
					border: selected ? '6px solid ' + indigo[300] : undefined,
					height: 120 - (selected ? 6 * 2 : 0),
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					margin: 12,
					cursor: 'pointer'
				}}
				onClick={onChange ? () => onChange(chord) : undefined}
				elevation={selected ? 6 : 2}
			>
				<CardContent style={{
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
				}}>
					<Typography variant="h5" component="h2" style={{ marginBottom: 4 }}>
						{chord.symbol}
					</Typography>
					<Typography variant="body2" component="p">
						{chord.notes.join(' • ')}
					</Typography>
				</CardContent>

				<IconButton onClick={(e) => {e.stopPropagation(); onPlayClick(chord)}} className={classes.iconButtonPlay} edge="start" color="inherit" aria-label="play audio">
					<VolumeUpIcon className={classes.iconPlay} />
				</IconButton>

			</Card>
		</div>
	)
}

export default ChordCard
